/**
 * Detalle útil cuando falla una petición Axios (403, 401, blob de error JSON, Network Error).
 */
export function logAxiosError(contextLabel, error) {
  console.group(`[API Error] ${contextLabel}`);
  console.error("message:", error?.message ?? error);

  const cfg = error?.config;
  if (cfg) {
    const url = `${cfg.baseURL ?? ""}${cfg.url ?? ""}`;
    console.info("→", String(cfg.method || "get").toUpperCase(), url);
    if (cfg.params && Object.keys(cfg.params).length > 0) {
      console.info("params:", cfg.params);
    }
    if (cfg.skipAuth === true) {
      console.info("(skipAuth: sin token Bearer)");
    }
  }

  const res = error?.response;
  if (res) {
    console.error(`HTTP ${res.status} ${res.statusText}`);
    const data = res.data;
    if (typeof Blob !== "undefined" && data instanceof Blob) {
      data
        .text()
        .then((text) => {
          const trimmed = text.trim();
          if (!trimmed) {
            console.error("body (Blob vacío)");
            return;
          }
          try {
            console.error("body:", JSON.parse(trimmed));
          } catch {
            console.error("body (texto):", trimmed.slice(0, 2000));
          }
        })
        .catch(() => console.error("body (Blob binario):", data.type || "?", data.size, "bytes"));
    } else {
      console.error("body:", data);
    }
  } else if (error?.request) {
    console.error(
      "Sin respuesta HTTP (timeout, red, CORS o servidor inalcanzable). Revisa URL base y que la API esté arriba."
    );
  }

  console.groupEnd();
}
